export const dateStyles = {
  month: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  monthText: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "18px",
    color: "#666666",
  },
  expand: {
    marginLeft: "8px",
  },
};
